import { Dropdown } from "@octopus-energy/coral/atoms"
import { type MenuItem } from "@/features/navigation/types/menuItem"
import { NavigationMenu } from "../NavigationMenu"

type NavigationMenuListProps = {
    items: MenuItem[]
}

export function NavigationMenuList({ items }: NavigationMenuListProps) {
    return (
        <>
            {items.map((item) => (
                <Dropdown
                    key={item.key}
                    offset={0}
                    placement="bottom-start"
                >
                    <NavigationMenu item={item} />
                </Dropdown>
            ))}
        </>
    )
}
